import { useTranslation } from 'react-i18next';
import InfoCard from '@client/components/ui/cards/InfoCard';

// Considère un champ comme vide quand sa valeur est null/undefined ou,
// après strip HTML + trim, ne contient aucun caractère imprimable. Couvre
// les cas « zone de texte vidée » qui laissent en BD soit '' soit des
// blancs (espaces, sauts de ligne) soit un wrapper rich-text vide comme
// '<p></p>' ou '<p><br></p>'.
const isEmptyValue = (value) => {
  if (value == null) return true;
  if (typeof value !== 'string') return false;
  const stripped = value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
  return stripped === '';
};

const CustomFieldsSection = ({ fields }) => {
  const { t } = useTranslation();

  if (!fields || fields.length === 0) return null;

  const fieldsWithValue = fields.filter((f) => !isEmptyValue(f.value));
  if (fieldsWithValue.length === 0) return null;

  return (
    <>
      <h3 className="title-underlined normal-case mt-4 !text-[18px]">
        {t('common|Informations additionnelles')}
      </h3>
      <div className="grid grid-cols-1 gap-4">
        {fieldsWithValue.map((field) => (
          <InfoCard
            key={field.name}
            title={field.label}
            text={field.value}
          />
        ))}
      </div>
    </>
  );
};

export default CustomFieldsSection;
